import { Box, styled } from "@mui/material";

export const StyledArtmenu = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "2rem",
  flexDirection: "column",
  gap: "1rem",
  width: "100rem",
  ".content": {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    justifyContent: "center",
    maxHeight: "45rem",
    overflow: "scroll",
    ".imageWrapper": {
      width: "30rem",
      height: "20rem",
      borderRadius: "10px",
      overflow: "hidden",
      position: "relative",
      border: `4px solid ${theme.color.background}`,
      cursor: "pointer",
      img: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      },
      ".removebtn": {
        position: "absolute",
        right: "1rem",
        top: "1rem",
      },
    },
    ".selected": {
      borderColor: theme.color.contrastColor,
    },
    ".addImageBtn": {
      width: "30rem",
      height: "20rem",
      borderRadius: "10px",
      background: theme.contrast.lighter,
      color: theme.color.main,
      "&:hover": {
        background: theme.color.contrastColor,
        color: theme.color.background,
      },
    },
  },
}));
